import React from 'react'
import {Button, CircularProgress} from '@mui/material'

import './index.scss'

interface PrimaryButtonProps {
    className?: string
    text?: string
    onClick?(...args: unknown[]): unknown
    type?: string
    isLoading?: boolean
    disabled?: boolean
}

const PrimaryButton = ({className, text, onClick, type, isLoading, disabled}: PrimaryButtonProps) => (
    <Button
        className={`${className} primary-btn`}
        onClick={onClick}
        type={type}
        disabled={disabled ?? isLoading}
        href=''
    >
        {isLoading ? <CircularProgress size={24} className='loginSubmit-btn-progress' /> : text}
    </Button>
)

PrimaryButton.defaultProps = {
    type: 'button',
    isLoading: false,
    disabled: false
}

export default PrimaryButton
